import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle and rectangle sharing a vertex:
 * Triangle vertex A = Rectangle corner A.
 *
 * Uses PointTarget: t1's vertex A is pinned to r1's corner A.
 */
export const SHARED_POINT_PRESET: GeometryPadWidgetConfig = {
  id: 'shared-point',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 6, h: 4 },
      },
      t1: {
        type: 'Triangle',
        params: { a: 4, b: 5, gamma: 50, A: { x: 'r1.point.A.x', y: 'r1.point.A.y' } },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
